import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  border-radius: 8px;
  box-sizing: border-box;
  width: 700px;
`

export const LoadingContainer = styled(Container)`
  width: 700px;
  justify-content: center;
`
